

export function isExternal(path) {
    return /^(https?:|mailto:|tel:)/.test(path)
  }

  export function stripscript(s) {
    var pattern = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）&;—|{ }【】‘；：”“'。，、？]")
     var rs = "";
     for (var i = 0; i < s.length; i++) {
           rs = rs + s.substr(i, 1).replace(pattern, '');
     }
   return rs;
}

/* 
*验证邮箱
*/
export function validateEmail(value){
   let reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
   if(!reg.test(value)){
       return true
   }else{
       return false
   }
}

/* 验证密码 */

export function validatePassword(value){
    let reg = /^(?!\D+$)(?![^a-zA-Z]+$)\S{6,20}$/; 
    if(!reg.test(value)){
        return true
    }else{
        return false
    }
}
/* 验证验证码 */
export function validateCode(value){
    let reg = /^[0-9]{6}$/;
    if(!reg.test(value)){
        return true
    }else{
        return false
    }
}
/* 手机号码验证 */

export function validatePhone(value){
    let reg = /^(?:(?:\+|00)86)?1\d{10}$/;
    if(!reg.test(value)){
        return true
    }else{
        return false
    }
}